/**
 * Reference: https://www.figma.com/file/HDYZU5lpVEyhwgz0BqkM99/Mobile-Design-Library-2.0?node-id=114%3A1395
 */

export const FlipColors = {
  neutral: {
    MainText: "#222223",
    SecondaryText: "#747474",
    Placeholder: "#AAABAD",
    BorderAndDisabled: "#E3E3E4",
    Container: "#F3F5F6",
    White: "#FFFFFF",
    lightGrey: "#DEDEDE",
  },

  flipOrange: {
    Plus2: "#7E3221",
    Plus1: "#D35437",
    Main: "#FD6542",
    Minus1: "#FE9881",
    Minus2: "#FEC1B3",
    Minus3: "#FFF5F3",
  },

  goldenYellow: {
    Plus2: "#543D07",
    Plus1: "#A87A0D",
    Main: "#FFB207",
    Minus1: "#FDCF62",
    Minus2: "#FEE7B1",
    Minus3: "#FDF6DC",
  },

  crimsonRed: {
    Plus2: "#8A1A38",
    Plus1: "#C61F4D",
    Main: "#EE255C",
    Minus1: "#F46E92",
    Minus2: "#F9B6C9",
    Minus3: "#FDE9EF",
  },

  jadeGreen: {
    Plus2: "#236057",
    Plus1: "#2F7F74",
    Main: "#46BFAE",
    Minus1: "#84D4C9",
    Minus2: "#C1EAE4",
    Minus3: "#DAF2EF",
  },

  sapphireBlue: {
    Plus2: "#1D2D44",
    Plus1: "#3A5988",
    Main: "#5786CC",
    Minus1: "#8FAEDD",
    Minus2: "#C7D7EE",
    Minus3: "#DDE7F5",
  },

  mauvePurple: {
    Plus2: "#3B0A2D",
    Plus1: "#75135B",
    Main: "#B01D88",
    Minus1: "#CA68B0",
    Minus2: "#E5B4D7",
    Minus3: "#EFD2E7",
  },
};

export default FlipColors;
